import $$ from 'dom7';
import 'timepicker/jquery.timepicker';

import jQuery from 'jquery';
window.jQuery = jQuery;
window.$ = jQuery;
import { timepicker } from 'timepicker';

import 'timepicker/jquery.timepicker.css';

import Framework7, { Template7 } from 'framework7/framework7.esm.bundle.js';
import babelPolyfill from 'babel-polyfill';
import { translateKey } from 'reword-js';

//import {moment} from 'moment';
var moment = require('moment');

import 'dhtmlx-scheduler/codebase/dhtmlxscheduler.js';
import 'dhtmlx-scheduler/codebase/dhtmlxscheduler_material.css';
import 'dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_timeline.js';
import 'dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_limit.js';
import 'dhtmlx-scheduler/codebase/dhtmlxscheduler.css';
// Import F7 Styles
import 'framework7/css/framework7.bundle.css';
import '../js/api.js';
// Import Icons and App Custom Styles
import '../css/icons.css';
import '../css/app.css';
import '../css/login.css';
import '../css/dashboard.css';
import '../css/framework7-icons.css';
import '../css/activity.css';
import '../css/messages.css';
import '../css/cancellations.css';
import '../css/reservations-in-activity.css';
import '../css/pms.css';
import '../css/reservations-calendar.css';
// Import Cordova APIs

import cordovaApp from './cordova-app.js';
// Import Routes
import routes from './routes.js';
import dictionary from '../js/translation.js';
import Actions from '../js/actions.js';

import { config, changeLocale } from 'reword-js';

var app = new Framework7({
    root: '#app', // App root element
    id: 'io.roomrack.myapp', // App bundle ID
    name: 'RoomRack', // App name,
    theme: 'md', // Automatic theme detection
    // App root data
    view: {
        pushStateSeparator: '#',
        pushStateOnLoad: false,
        history: true,
        pushState: true,
    },
    popup: {
        closeByBackdropClick: false,
    },
    data: function () {
        return {
            user: {
                firstName: 'John',
                lastName: 'Doe',
            },

            // Demo products for Catalog section
            products: [
                {
                    id: '1',
                    title: 'Apple iPhone 8',
                    description:
                        'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nisi tempora similique reiciendis, error nesciunt vero, blanditiis pariatur dolor, minima sed sapiente rerum, dolorem corrupti hic modi praesentium unde saepe perspiciatis.',
                },
                {
                    id: '2',
                    title: 'Apple iPhone 8 Plus',
                    description:
                        'Velit odit autem modi saepe ratione totam minus, aperiam, labore quia provident temporibus quasi est ut aliquid blanditiis beatae suscipit odio vel! Nostrum porro sunt sint eveniet maiores, dolorem itaque!',
                },
                {
                    id: '3',
                    title: 'Apple iPhone X',
                    description:
                        'Expedita sequi perferendis quod illum pariatur aliquam, alias laboriosam! Vero blanditiis placeat, mollitia necessitatibus reprehenderit. Labore dolores amet quos, accusamus earum asperiores officiis assumenda optio architecto quia neque, quae eum.',
                },
            ],
        };
    },
    // App root methods
    methods: {
        helloWorld: function () {
            app.dialog.alert('Hello World!');
        },

        translate: function (text) {
            return 'test';
        },
    },
    // App routes
    routes: routes,

    // Input settings
    input: {
        scrollIntoViewOnFocus: Framework7.device.cordova && !Framework7.device.electron,
        scrollIntoViewCentered: Framework7.device.cordova && !Framework7.device.electron,
    },
    // Cordova Statusbar settings
    statusbar: {
        iosOverlaysWebView: true,
        androidOverlaysWebView: false,
    },
    on: {
        init: function () {
            document.addEventListener('backbutton', onBackKeyDown, false);
            var f7 = this;
            if (f7.device.cordova) {
                // Init cordova APIs (see cordova-app.js)
                cordovaApp.init(f7);
            }

            function OpenReservation(oneSiganlReservationID) {
                console.log('app js ' + oneSiganlReservationID);

                try {
                    app.views.main.router.navigate({
                        name: 'reservation-info',
                        params: { id: oneSiganlReservationID },
                    });
                } catch (ex) {
                    alert(ex);
                }
            }

            try {
                function OneSignalInit() {
                    // Uncomment to set OneSignal device logging to VERBOSE
                    // window.plugins.OneSignal.setLogLevel(6, 0);
                    // NOTE: Update the setAppId value below with your OneSignal AppId.
                    window.plugins.OneSignal.initialize('29f4c04f-2340-483e-9339-7d5576bf611c');
                    window.plugins.OneSignal.Notifications.addEventListener(function (jsonData) {
                        console.log('notificationOpenedCallback: ' + JSON.stringify(jsonData));
                        var oneSiganlReservationID = '';
                        oneSiganlReservationID = jsonData.notification.launchURL.split('//')[1];
                        OpenReservation(oneSiganlReservationID);

                        //kta kratisei to resid \=
                        //valto sto localstorage san mia paramentro notificationResarvationID= XXX
                        // kanei redirect sti selida kratisis

                        //bakend na exoume status kratisis, logo property, NEW + reservation ID to sbuject tou email
                        //minimataki
                    });

                    //Prompts the user for notification permissions.
                    //    * Since this shows a generic native prompt, we recommend instead using an In-App Message to prompt for notification permission (See step 6) to better communicate to your users what notifications they will get.
                    // window.plugins.OneSignal.promptForPushNotificationsWithUserResponse(function (accepted) {
                    //   console.log("User accepted notifications: " + accepted);
                    // });
                    window.plugins.OneSignal.Notifications.requestPermission(true).then((accepted) => {
                        console.log('User accepted notifications: ' + accepted);
                    });
                }
                OneSignalInit();
            } catch (error) {}

            var language = localStorage.getItem('language');

            if (language == null) {
                language = 'en-US';
                moment.locale('en'); // default the locale to English
            }
            config(dictionary, { locale: language });
            moment.locale(language);
            console.log('language', language);

            try {
                // FirebasePlugin.grantPermission(function (hasPermission) {
                //   console.log(
                //     "Permission was " + (hasPermission ? "granted" : "denied")
                //   );
                // });
                // FirebasePlugin.onTokenRefresh(
                //   function (fcmToken) {
                //     console.log(fcmToken);
                //   },
                //   function (error) {
                //     console.error(error);
                //   }
                // );
                // FirebasePlugin.onMessageReceived(
                //   function (message) {
                //     console.log("Message type: " + message.messageType);
                //     if (message.messageType === "notification") {
                //       console.log("Notification message received");
                //       if (message.tap) {
                //         console.log("Tapped in " + message.tap);
                //       }
                //     }
                //     console.dir(message);
                //   },
                //   function (error) {
                //     console.error(error);
                //   }
                // );
                // cordova.plugins.firebase.messaging.requestPermission({forceShow: true}).then(function() {
                //   console.log("You'll get foreground notifications when a push message arrives");
                // });
                // cordova.plugins.firebase.messaging.onMessage(function(payload) {
                //   console.log("New foreground FCM message: ", payload);
                // });
                // cordova.plugins.firebase.messaging.onBackgroundMessage(function(payload) {
                //   console.log("New background FCM message: ", payload);
                // });
                // cordova.plugins.firebase.messaging.onTokenRefresh(function() {
                //   console.log("Device token updated");
                // });
            } catch (exception) {}
        },
    },
});

//edw dilswnw helper synarhth
Template7.registerHelper('t', function (name) {
    return translateKey(name);
});
Template7.registerHelper('FormatDate', function (type, date) {
    //var date='2-22-1991'
    // return  moment(date).format('LLLL');

    if (type == 1) {
        return moment(date, 'DD-MM-YYYY').format('dddd, DD MMMM YYYY');
    } else if (type == 2) {
        return moment(date).format('DD-MM-YYYY');
    } else if (type == 3) {
        return moment(date).format('DD MMMM');
    } else {
        return moment(date).format('DD MMMM YYYY');
    }
});
Template7.registerHelper('Getmonthname', function (monthvar) {
    //var date='2-22-1991'
    // return  moment(date).format('LLLL');

    var prevMonthName = moment()
        .month(monthvar - 1)
        .format('MMMM');
    return prevMonthName;
});

Template7.registerHelper('Compare2Dates', function (date1, date2) {
    //var date='2-22-1991'
    // return  moment(date).format('LLLL');

    const d1 = new Date(date1);
    const d2 = new Date(date2);
    if (d1 == d2) {
        return true;
    } else {
        return false;
    }
});

Template7.registerHelper('ifcompare', function (a, operator, b, options) {
    var match = false;

    if (
        (operator === '==' && a == b) ||
        (operator === '===' && a === b) ||
        (operator === '!=' && a != b) ||
        (operator === '>' && a > b) ||
        (operator === '<' && a < b) ||
        (operator === '>=' && a >= b) ||
        (operator === '<=' && a <= b)
    ) {
        match = true;
    }
    if (match) return options.fn(this);
    else return options.inverse(this);
});

// window.onhashchange = function (e) {
//   var exitappdialog = app.f7.dialog.create({
//     title: "",
//     text: "Are you sure want to exit the app?",
//     buttons: [
//       {
//         text: "Cancel",
//         cssClass: "dialogcancelbtn",
//         onClick: function () {
//           console.log("declined");
//         },
//       },
//       {
//         text: "Exit",
//         cssClass: "logoutbtn",
//         onClick: function () {
//           localStorage.clear();
//           console.log("LogOut");
//           // app.f7.views.main.router.navigate("/login/", {
//           //   transition: "f7-dive",
//           // });
//           // window.navigator.app.exitApp();
//         },
//       },
//     ],
//   });
//   exitappdialog.open();
// };
function onBackKeyDown() {
    if (app.views.main.router.url == '/login/') {
    }
    // if (app.views.main.router.previousRoute.path !=null && app.views.main.router.previousRoute.path == "/NewCalendar/") {
    //     app.views.main.router.back(app.views.main.router.previousRoute.path,
    //         {
    //           ignoreCache: true,  force: true

    //             });

    // }
}
// Login Screen Demo
$$('#my-login-screen .login-button').on('click', function () {
    var username = $$('#my-login-screen [name="username"]').val();
    var password = $$('#my-login-screen [name="password"]').val();

    // Close login screen
    app.loginScreen.close('#my-login-screen');

    // Alert username and password
    app.dialog.alert('Username: ' + username + '<br>Password: ' + password);
});

// $$('#logoutbtn').on('click', function () {

//   localStorage.clear();

//   console.log("LogOut");
//   app.views.main.router.navigate('/login/', { transition: 'f7-dive' });

// });

// $$('#English').on('click', function () {
//   const newLanguage = 'en-US';
//   localStorage.setItem('language', newLanguage);
//   moment.locale(newLanguage);
//   changeLocale(newLanguage);
//   app.views.main.router.refreshPage();
// });

// $$('#Greek').on('click', function () {
//   const newLanguage = 'el-GR';
//   localStorage.setItem('language', newLanguage);
//   changeLocale(newLanguage);
//   moment.locale(newLanguage);
//   app.views.main.router.refreshPage();
// });
